import { INTERNALFlag, useINTERNALFlag, PropsNoName } from '@components/Flag';
/** [ME-23189](https://masterysys.atlassian.net/browse/ME-23189) Displays planning navigation dropdown */
export const useFlagMe23189ViewPlanningNavItem = (): boolean => useINTERNALFlag('ME-23189-view-planning-nav-item');
/** [ME-23189](https://masterysys.atlassian.net/browse/ME-23189) Displays planning navigation dropdown */
export const FlagMe23189ViewPlanningNavItem = (props: PropsNoName) => <INTERNALFlag name="ME-23189-view-planning-nav-item" {...props}/>
